const NotFound = () => {
  window.location.href = "https://arsann.com/";
  return <></>;
};

export default NotFound;
